module.exports = __webpack_public_path__ + "img/answer-capacitor.627dbc31.webp";